export enum RequestStatusEnum {
  RequestInDraft = 1,
  PendingForAcknowledgement = 2,
  ReopenedByRnDHead = 3,
  RequestAssignmentPending = 4,
  TaskAssignmentPending = 5,
  TasksWIPWithTaskOwner = 6,
  PendingForRequestClosureRnDManager = 7,
  PendingForRequestClosureRnDHead = 8,
  RequestClosed = 9,
  SendbackByRnDHead=10,
}
